"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_property_decorator_1 = require("vue-property-decorator");
const base_button_vue_1 = tslib_1.__importDefault(require("@/components/base-button/base-button.vue"));
const vuex_1 = require("vuex");
const utils_1 = require("@/utils");
const logger_1 = require("@/utils/logger");
let VehicleTileFooter = class VehicleTileFooter extends vue_property_decorator_1.Vue {
    getButtonTypeForClassification(classification) {
        switch (classification) {
            case utils_1.BUTTON_TYPE.CALL_TO_ACTION:
                return 'primary';
            default:
                return 'secondary';
        }
    }
    handleClick(id) {
        logger_1.logger.info(`button with id: ${id} clicked`);
        this.$emit('button-clicked', id);
    }
};
VehicleTileFooter = tslib_1.__decorate([
    (0, vue_property_decorator_1.Component)({
        name: 'VehicleTileFooter',
        components: { BaseButton: base_button_vue_1.default },
        computed: Object.assign({}, (0, vuex_1.mapGetters)(['buttons'])),
    })
], VehicleTileFooter);
exports.default = VehicleTileFooter;
